import { SchoolCycleSelect, ErrorBoundary } from 'components'
import { ReportExport } from 'pages/reports/ReportExport'
import { useGetStudentsReportQuery } from 'features'

export function StudentReportSchoolCycleSelect({ resource, ..._props }) {
  const { customFilterParamsHandler, customFilterParams } = resource

  function handleSchoolCycleChange(event) {
    customFilterParamsHandler({
      cycle: event.target.value,
    })
  }

  return (
    <div className="flex flex-row justify-end items-center mt-32 gap-4 ">
      <ErrorBoundary>
        <SchoolCycleSelect
          value={customFilterParams.cycle}
          onChange={handleSchoolCycleChange}
        />
        <ReportExport
          query={useGetStudentsReportQuery}
          title="Reporte de Estudiantes"
          fileName="Reporte de Estudiantes"
          dataFormat="array"
          queryParams={customFilterParams}
          preExport={(data) => {
            let returnData = [['ciclo Escolar', customFilterParams.cycle]]
            const keyMap = {
              cycleLimit: 'Límite de acreditación',
              notReadyForApproval: 'No listos para aprobación',
              notAcredited: 'No recibieron acreditación alguna',
              partialAccreditation: 'Acreditación parcial',
              pendingApproval: 'Aprobaciones pendientes',
              rejected: 'Rechazados',
              totalAccreditation: 'Alumnos con acreditación total',
            }
            Object.keys(data).forEach((key) => {
              if (keyMap[key]) {
                returnData.push([keyMap[key], data[key]])
              }
            })
            return returnData
          }}
        />
      </ErrorBoundary>
    </div>
  )
}
